import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { ShieldCheck, Lock, CreditCard, Zap } from 'lucide-react';
export const FinalCTA = () => {
  return <section className="py-8 md:py-14 bg-sage-50 border-t border-sage-100" data-id="element-90">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-91">
        <div className="mb-8 md:mb-16" data-id="element-92">
          <CountdownTimer data-id="element-93" />
        </div>

        <div className="space-y-5 md:space-y-8" data-id="element-94">
          {/* Standard Offer */}
          <div className="bg-white rounded-2xl md:rounded-3xl p-5 md:p-8 shadow-sm border border-gray-200 text-center" data-id="element-95">
            <h3 className="text-lg md:text-2xl font-bold text-charcoal mb-1 md:mb-2 font-playfair" data-id="element-96">
              📘 PILATES 360 — SISTEMA COMPLETO
            </h3>
            <p className="text-sm text-gray-600 mb-4 md:mb-6" data-id="element-97">
              6 Tomos + 6 Bonos
            </p>
            <div className="flex justify-center items-end gap-2 md:gap-3 mb-4 md:mb-6" data-id="element-98">
              <span className="text-sm md:text-xl text-gray-400 line-through" data-id="element-99">
                Antes: $34.990 ARS
              </span>
              <span className="text-2xl md:text-4xl font-bold text-charcoal" data-id="element-100">
                Hoy: $19.990 ARS
              </span>
            </div>
            <a href="https://checkout.rincondigital.shop/cart/54020862804243:1" className="inline-block w-full md:w-auto px-6 py-3 md:px-8 md:py-4 bg-sage hover:bg-sage-600 text-white font-bold rounded-xl transition-colors text-sm md:text-base" data-id="element-101">
              → QUIERO MI PILATES 360 AHORA
            </a>
          </div>

          {/* Premium Offer */}
          <div className="bg-sage-900 rounded-2xl md:rounded-3xl p-5 md:p-8 shadow-xl text-center relative overflow-hidden" data-id="element-102">
            <div className="absolute top-0 right-0 bg-gold text-sage-900 font-bold px-4 py-1.5 md:px-6 md:py-2 rounded-bl-xl md:rounded-bl-2xl text-xs md:text-sm" data-id="element-103">
              La más elegida ⭐
            </div>
            <h3 className="text-lg md:text-2xl font-bold text-white mb-1 md:mb-2 font-playfair mt-4" data-id="element-104">
              🏆 PILATES 360 + SAFE PILATES PRO™
            </h3>
            <p className="text-sm text-sage-200 mb-1 md:mb-2" data-id="element-105">
              6 Tomos + 6 Bonos + Safe Pilates Pro™
            </p>
            <p className="text-xs text-gray-400 italic mb-4 md:mb-6 max-w-lg mx-auto" data-id="element-106">
              (Guía completa de adaptaciones para 18 patologías, checklist de
              seguridad y protocolo de emergencia)
            </p>
            <div className="flex justify-center items-end gap-2 md:gap-3 mb-4 md:mb-6" data-id="element-107">
              <span className="text-sm md:text-xl text-gray-500 line-through" data-id="element-108">
                Antes: $43.990 ARS
              </span>
              <span className="text-2xl md:text-4xl font-bold text-gold" data-id="element-109">
                Hoy: $27.990 ARS
              </span>
            </div>
            <a href="https://checkout.rincondigital.shop/cart/54020862935315:1" className="inline-block w-full md:w-auto px-6 py-3 md:px-8 md:py-4 bg-gold hover:bg-gold-dark text-sage-900 font-bold text-sm md:text-lg rounded-xl transition-colors shadow-lg" data-id="element-110">
              → QUIERO EL PILATES 360 + SAFE PILATES PRO
            </a>
          </div>
        </div>

        <div className="mt-8 md:mt-12 flex flex-wrap justify-center gap-3 md:gap-6 text-xs md:text-sm text-gray-600 font-medium" data-id="element-111">
          <div className="flex items-center gap-2" data-id="element-112">
            <Lock className="w-4 h-4 text-sage" data-id="element-113" /> Pago 100% seguro
          </div>
          <div className="flex items-center gap-2" data-id="element-114">
            <Zap className="w-4 h-4 text-gold" data-id="element-115" /> Acceso en 5 minutos
          </div>
          <div className="flex items-center gap-2" data-id="element-116">
            <ShieldCheck className="w-4 h-4 text-sage" data-id="element-117" /> Garantía 7 días sin
            preguntas
          </div>
          <div className="flex items-center gap-2" data-id="element-118">
            <CreditCard className="w-4 h-4 text-sage" data-id="element-119" /> Mercado Pago | Tarjeta
            | Transferencia
          </div>
        </div>
      </div>
    </section>;
};